import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface BannerProps {
  children: ReactNode;
  className?: string;
}

const createBanner = (colorClasses: string) => {
  const Banner = (props: BannerProps) => (
    <div className={cn('flex items-center gap-3 rounded-xl border', colorClasses, props.className)}>
      {props.children}
    </div>
  );
  return Banner;
};

export const AmberBanner = createBanner('border-amber-500/20 bg-amber-500/[0.06] px-4 py-3');
export const RedBanner = createBanner('border-red-500/20 bg-red-500/[0.06] px-4 py-3');
export const ZincBanner = createBanner('border-zinc-500/20 bg-zinc-500/[0.06] px-4 py-3');
